<!-- 
  -- Projet: Gestion des stagiaires
  -- Auteur : Tim Allemann
  -- Date : 23.09.2022
  -- Description : Formulaire de suppression d'une activité
  -- Fichier : DeleteTypeIntershipActivity.vue
  -->

<template>
  <v-form
    ref="formDeleteTypeIntershipActivity"
    v-model="validCreateTypeIntershipActivity"
    lazy-validation
  >
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          tile
          color="red"
          dark
          min-width="150"
          class="ma-2"
        >
          Supprimer
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Supprimer une activité</span>
        </v-card-title>
        <v-card-text>
          <h3 class="mb-3">
            Attention une suppression est définitive !
          </h3>
          <v-card
            class="mx-auto"
            tile
            v-if="typeIntershipActivity.stages.length > 0"
          >
            <v-list disabled>
              <v-subheader
                >Il faut supprimer les stages lié à cette activité avant de
                supprimer l'activité ou changer l'activité de ces
                stages</v-subheader
              >
              <v-list-item-group
                v-model="typeIntershipActivity.stages"
                color="primary"
              >
                <v-list-item
                  v-for="(stages, i) in typeIntershipActivity.stages"
                  :key="i"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      name="nom"
                      v-text="stages.stageId"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Fermer
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="deleteTypeIntershipActivity()"
            v-if="typeIntershipActivity.stages.length == 0"
          >
            Supprimer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import store from '@/store/index.js'
import NProgress from 'nprogress'

export default {
  props: {
    typeIntershipActivity: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    validCreateTypeIntershipActivity: true,
    dialog: false
  }),

  methods: {
    // Supprime une activité
    deleteTypeIntershipActivity() {
      NProgress.start()
      store
        .dispatch(
          'typeIntershipActivity/deleteTypeIntershipActivity',
          this.typeIntershipActivity.typeIntershipActivityId
        )
        .then(() => {
          this.$router.push({
            name: 'Activites'
          })
        })
        .catch(() => {})
      this.dialog = false
      NProgress.done()
    }
  }
}
</script>
